import React from 'react';
import { HStack, PinInput, PinInputField } from '@chakra-ui/core';

interface CodeInputProps {
  verificationCode: string;
  onChange: (value: string) => void;
  onComplete: ((value: string) => void) | undefined;
  isFromInterview?: boolean;
}

const ConfirmationCodeInput = ({ verificationCode, onChange, onComplete, isFromInterview }: CodeInputProps): JSX.Element => {
  const pinFields = Array.from({ length: 6 }, (_, i) => ({ id: `pin-${i}` }));
  return (
    <HStack data-testid="ConfirmationCodeInput">
      <PinInput
        key="ConfirmationCodeInput"
        autoFocus
        value={verificationCode}
        onChange={onChange}
        onComplete={onComplete}
        size={isFromInterview ? 'sm' : 'md'}
      >
        {pinFields.map(({ id }) => (
          <PinInputField key={id} type="number" />
        ))}
      </PinInput>
    </HStack>
  );
};

ConfirmationCodeInput.defaultProps = {
  isFromInterview: false,
};

export default ConfirmationCodeInput;
